import { Button, getUserFacingErrorMessage } from "@coval/ui"
import { AlertTriangle } from "lucide-react"

import { EmptyStateCTA } from "@/components/EmptyStateCTA"

interface ConversationsErrorStateProps {
  error: unknown
  onRetry: () => void
}

/**
 * Failure surface for the uploaded conversations page. Stands in for the table
 * whenever a fetch the table cannot work without has failed, so a dead request
 * settles on a retry instead of an endless skeleton or a misleading
 * "no conversations yet" call to action.
 */
export function ConversationsErrorState({
  error,
  onRetry,
}: ConversationsErrorStateProps) {
  return (
    <EmptyStateCTA
      icon={AlertTriangle}
      title="Couldn't load conversations"
      description={getUserFacingErrorMessage(error, {
        fallback:
          "Something went wrong loading your uploaded conversations. Try again in a moment.",
      })}
      data-testid="uploaded-conversations-error-state"
    >
      <Button variant="default" onClick={onRetry}>
        Try again
      </Button>
    </EmptyStateCTA>
  )
}
